import ApiService from './ApiService';

export default class FileApi extends ApiService {
    uploadImage(payload: FormData) {
        return this.post('end/file', payload, { headers: { 'Content-Type': 'multipart/form-data' } });
    }
}
